import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useAppSelector } from "hooks/app-hook";

const GameLoadingBackdrop = () => {
  const loading = useAppSelector((state) => state.ui.gameLoading);

  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(0,0,0,0.65)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin
        indicator={
          <LoadingOutlined style={{ fontSize: 58, color: "#53d37e" }} spin />
        }
        tip="Entering game..."
      />
    </div>
  );
};

export default GameLoadingBackdrop;
